<template>
  <div class="card-item space-between">
    <div :class="bindItemTitleClass" :style="{ color: bindCardTitleStyle }">
      {{ title }}
      <div v-if="showCountdown" class="time">
        {{ $t('coupon.expiring') }}
        <Countdown :userCouponExpireTime="userCouponExpireTime" />
      </div>
    </div>
    <div @click="handleArrow" class="flex-start">
      <van-loading v-if="loading" type="spinner" class="loading-icon" />
      <div
        v-else
        class="amount flex-start"
        :class="isDiscount ? 'orange' : 'white'"
      >
        <GeneralPrice
          :injectColor="bindCardTitleStyle"
          :className="'c-money'"
          :prefix="isDiscount ? '-' : ''"
          :price="Number(amount)"
        />
      </div>
      <MBIcon
        v-if="showArrow"
        name="icon-arrow"
        :color="bindCardTitleStyle"
        :size="32"
      />
    </div>
  </div>
</template>
<script>
  // 支付明细 - 单列
  import MBIcon from '@/components/MBIcon'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import GeneralPrice from '@/components/GeneralPrice'
  import Countdown from '../Countdown'
  import { mapState } from 'vuex'
  import { isNewGenshin } from '../utils'

  export default {
    mixins: [styleConfiguration],
    components: {
      MBIcon,
      // MoneyDisplay,
      Countdown,
      GeneralPrice,
    },
    props: {
      // 金额类名
      title: {
        type: String,
        default: 'white',
      },
      // 是否是优惠项
      isDiscount: {
        type: Boolean,
        default: false,
      },
      // 是否展示loading
      loading: {
        type: Boolean,
        default: false,
      },
      // 金额
      amount: {
        type: Number,
        default: 0,
      },
      // 是否展示箭头
      showArrow: {
        type: Boolean,
        default: false,
      },
      // 是否展示倒计时
      showCountdown: {
        type: Boolean,
        default: false,
      },
      // 优惠券过期时间 单位s，从接口获取到的数据
      userCouponExpireTime: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        show: true,
      }
    },
    computed: {
      ...mapState(['gameName']),
      bindCardTitleStyle() {
        if (isNewGenshin(this.gameName)) return '#93735C'
        return this.priceColor.color
      },
      bindItemTitleClass() {
        const classList = ['desc', 'flex-col', 'limit-game-desc']
        return classList
      },
    },
    methods: {
      handleArrow() {
        if (this.showArrow) {
          this.$emit('handleArrow')
        }
      },
    },
  }
</script>
<style lang="scss" scoped src="./CardItem.scss"></style>
